import { Lock } from 'lucide-react'

interface BuilderLockedBannerProps {
  children: React.ReactNode
}

/** Shown wherever a config panel has switched from "pick one" to "confirming what
 * Workflow Builder already decided" — a small, consistent way to explain why the
 * usual pickers are greyed out instead of just silently disabling them. */
export function BuilderLockedBanner({ children }: BuilderLockedBannerProps) {
  return (
    <div className="flex items-start gap-2 px-3 py-2.5 rounded-[9px]" style={{ background: 'rgba(99,102,241,.06)', border: '1px solid rgba(99,102,241,.25)' }}>
      <Lock size={12} className="text-[#4f46e5] shrink-0 mt-0.5" />
      <p className="text-[11px] text-[#1e293b] leading-snug">{children}</p>
    </div>
  )
}
